import { render, staticRenderFns } from "./supplierList.vue?vue&type=template&id=40873d1c&scoped=true&"
import script from "./supplierList.vue?vue&type=script&lang=js&"
export * from "./supplierList.vue?vue&type=script&lang=js&"
import style0 from "./supplierList.vue?vue&type=style&index=0&id=40873d1c&prod&lang=scss&scoped=true&"
import style1 from "./supplierList.vue?vue&type=style&index=1&id=40873d1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40873d1c",
  null
  
)

export default component.exports